import React from 'react';
import { ArrowLeft, Edit, Trash2, Calendar, User, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import CuttingPlanStatusBadge from './CuttingPlanStatusBadge';

const CuttingPlanHeader = ({ plan, onEdit, onDelete }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-4">
          <button
            onClick={() => navigate('/cutting-plans')}
            className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>

          <div>
            <div className="flex items-center gap-3 mb-2">
              <h1 className="text-2xl font-bold text-gray-900">
                {plan.plan_code}
              </h1>
              <CuttingPlanStatusBadge status={plan.status} size="md" />
            </div>

            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
              {plan.project_name && (
                <div className="flex items-center gap-1">
                  <Building2 className="w-4 h-4" />
                  <span>{plan.project_name}</span>
                </div>
              )}
              {plan.created_at && (
                <div className="flex items-center gap-1">
                  <Calendar className="w-4 h-4" />
                  <span>Criado em {formatDate(plan.created_at)}</span>
                </div>
              )}
              {plan.created_by_name && (
                <div className="flex items-center gap-1">
                  <User className="w-4 h-4" />
                  <span>Por {plan.created_by_name}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => onEdit?.(plan)}
            className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-blue-50 border border-gray-300 rounded-lg transition-colors"
          >
            <Edit className="w-4 h-4" />
            Editar
          </button>
          <button
            onClick={() => onDelete?.(plan)}
            className="flex items-center gap-2 px-4 py-2 text-gray-700 hover:text-red-600 hover:bg-red-50 border border-gray-300 rounded-lg transition-colors"
          >
            <Trash2 className="w-4 h-4" />
            Excluir
          </button>
        </div>
      </div>

      {plan.notes && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-600">
            <span className="font-medium">Observações:</span> {plan.notes}
          </p>
        </div>
      )}
    </div>
  );
};

export default CuttingPlanHeader;
